/**
 * Formatting helpers for web — thin re-export from @petci/shared-ui.
 * All formatting logic lives in packages/shared-ui/src/format.ts (single source of truth).
 */
export {
  formatCurrency,
  formatDate,
  formatBillDueDate,
  billDueIso,
  formatKwh,
  greeting,
  formatMonth,
  formatMonthNameLong,
  formatEta,
  formatEtaLong,
  formatStormEta,
  formatCountdown,
} from "@petci/shared-ui";
